import { useEyeStore } from '@/stores/eyeStore'
import type { MarketType } from '@/utils/types'
import { computed, type Ref } from 'vue'
import { useAutoRefresh } from '../useAutorefresh'

export const useCexUpdateMarketsRefresher = (
  marketType: Ref<MarketType>,
  asset: Ref<string>,
  exBuy: Ref<string>,
  exSell: Ref<string>,
  sellAsset: Ref<string | null>,
  quoteBuy: Ref<string>,
  quoteSell: Ref<string>,
) => {
  const eyeStore = useEyeStore()
  const marketsActionId = computed(() => `${asset.value}/${exBuy.value}/${exSell.value}/${sellAsset.value || 'none'}/${quoteBuy.value}/${quoteSell.value}`)
  const markets = computed(() => eyeStore.markets?.[marketsActionId.value])

  const marketsRefresher = useAutoRefresh(async () => {
    updateMarkets()
  }, 30000)

  const updateMarkets = async () => {
    if (!marketType.value || !asset.value || !exBuy.value || !exSell.value) {
      return false
    }
    const sellAssetValue = sellAsset.value || asset.value
    eyeStore.markets[marketsActionId.value] ??= {}
    await Promise.all([
      eyeStore.fetchMarkets(
        `${marketsActionId.value}_buy`,
        marketType.value,
        asset.value,
        [exBuy.value],
        null,
        quoteBuy.value,
      ),
      eyeStore.fetchMarkets(
        `${marketsActionId.value}_sell`,
        marketType.value,
        sellAssetValue,
        [exSell.value],
        null,
        quoteSell.value,
      ),
    ])
    const merged = eyeStore.markets[marketsActionId.value] ?? {}
    const buyMarkets = eyeStore.markets[`${marketsActionId.value}_buy`]
    const sellMarkets = eyeStore.markets[`${marketsActionId.value}_sell`]
    if (buyMarkets) {
      Object.assign(merged, buyMarkets)
    }
    if (sellMarkets) {
      Object.assign(merged, sellMarkets)
    }
    eyeStore.markets[marketsActionId.value] = merged
    return true
  }

  return {
    updateMarkets,
    markets,
    marketsRefresher,
  }
}
